import {isObject, eq} from '@shared/helpers/lang'
import {hasEveryOwnProperty} from '@shared/helpers/object'

import {
    DeliveryAttributeCode,
    DeliveryAttributeCodeType,
    InterestFreeInstallmentTypeType,
    InterestFreeInstallmentType,
    BranchDeliveryType,
    BranchDelivery,
    BranchMarketType,
    BranchMarket,
} from '@web/core/constants'

/** error 객체는 unknown 타입이기 때문에 unknown을 받아서 T 타입인지 확인하는 함수를 생성하는 함수 */
const createPredicate =
    <T extends object>(props: (keyof T)[]) =>
    (arg: unknown): arg is T =>
        isObject(arg) && hasEveryOwnProperty(arg, props)

/** error 객체에서 message 반환 */
export function getErrorMessage(e: Error | unknown, defaultMessage = ''): string {
    if (e instanceof Error || createPredicate(['message'])(e)) {
        return e.message
    }
    return defaultMessage
}

/** 도착보장 여부 (네이버 도착보장 + 판매자 도착보장 + 희망일 도착보장) */
export const isArrivalGuarantee = (deliveryAttributeType?: Maybe<DeliveryAttributeCodeType>): boolean => {
    const arrivalGuarantees: DeliveryAttributeCodeType[] = [
        DeliveryAttributeCode.ARRIVAL_GUARANTEE,
        DeliveryAttributeCode.SELLER_GUARANTEE,
        DeliveryAttributeCode.HOPE_SELLER_GUARANTEE,
    ]
    return !!(deliveryAttributeType && arrivalGuarantees.includes(deliveryAttributeType))
}

/** 희망일 도착보장 여부 */
export const isHopeSellerGuarantee = (deliveryAttributeType?: Maybe<DeliveryAttributeCodeType>): boolean => {
    return eq(deliveryAttributeType, DeliveryAttributeCode.HOPE_SELLER_GUARANTEE)
}

/** 판매자 도착보장 여부 */
export const isSellerGuarantee = (deliveryAttributeType?: Maybe<DeliveryAttributeCodeType>): boolean => {
    return eq(deliveryAttributeType, DeliveryAttributeCode.SELLER_GUARANTEE)
}

/** 희망일배송 여부 */
export const isHopeDelivery = (deliveryAttributeType?: Maybe<DeliveryAttributeCodeType>): boolean => {
    return eq(deliveryAttributeType, DeliveryAttributeCode.HOPE)
}

/** 컬리 주문 여부 */
export const isKurlyOrder = ({
    branchDeliveryType,
    branchMarketType,
}: {
    branchDeliveryType?: BranchDeliveryType
    branchMarketType?: BranchMarketType
}): boolean => {
    return eq(branchDeliveryType, BranchDelivery.KURLY) || eq(branchMarketType, BranchMarket.KURLYNMART)
}

/** TODO: month가 0 혹은 음수일시 처리가 필요할지 검토 필요 */
export const getInstallmentLabel = ({
    month,
    interestType,
}: {
    month: number
    interestType: InterestFreeInstallmentTypeType
}) => {
    if (month === 1) {
        return '일시불'
    }
    return `${
        interestType === InterestFreeInstallmentType.NONE
            ? ''
            : `${interestType === InterestFreeInstallmentType.PART ? '부분' : ''}무이자 `
    }${month}개월`
}
